<div class="flex-container">
  <div style="flex: 3">
    <div class="column">
      <app-text-input
        [label]="'Account Number'"
        [required]="true"
        [(ngModel)]="this.data.billingAccountNum"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>

    <div class="column">
      <app-text-input
        [label]="'Routing Number'"
        [required]="true"
        [(ngModel)]="this.data.billingRoutingNum"
        [readonly]="this.mode == FormMode.View"
      ></app-text-input>
    </div>

    <div class="column form-input">
      @if (this.data.billingAddress) {
        <app-street-address
          #billingAddressInfo
          [enableEditing]="this.enableEditing"
          [readonly]="this.mode == FormMode.View"
          [streetAddress]="this.data.billingAddress"
          [addressLabel]="'Billing address'"
        ></app-street-address>
      }
    </div>
  </div>

  <div style="flex: 3">
    <div class="column form-input">
      <app-ddl-input
        [label]="'Account Holder Type'"
        [required]="true"
        [(ngModel)]="this.data.billingAccountHolderType"
        [options]="accountHolderOptions"
        [readonly]="this.mode == FormMode.View"
      ></app-ddl-input>
    </div>

    <div class="column form-input">
      <app-ddl-input
        [label]="'Account Type'"
        [required]="true"
        [(ngModel)]="this.data.billingAccountType"
        [options]="accountTypeOptions"
        [readonly]="this.mode == FormMode.View"
      ></app-ddl-input>
    </div>
  </div>

  <div
    style="flex: 1; text-align: right"
    [hidden]="this.mode == formMode.New || !this.enableEditing"
  >
    <div
      style="
        float: right;
        background-color: #f7f7f7;
        padding: 3px;
        width: 25px;
        height: 25px;
        cursor: pointer;
      "
      title="Edit"
      [hidden]="this.mode == FormMode.Edit"
      (click)="btnEdit_click()"
    >
      <i class="fa-regular fa-pen-to-square icon"></i>
    </div>
    <div style="clear: both"></div>
  </div>
</div>

<div [hidden]="!this.enableEditing || this.mode == formMode.New">
  <input
    type="button"
    value="save"
    style="width: 200px"
    class="button_primary button_var_2 button_right-spacing"
    (click)="this.btnSaveClick()"
    (keydown.enter)="this.btnSaveClick()"
    [hidden]="this.mode != FormMode.Edit"
  />
  <input
    type="button"
    value="cancel"
    style="width: 200px"
    class="button_primary button_var_2"
    (click)="this.btnCancelClick()"
    (keydown.escape)="this.btnCancelClick()"
    [hidden]="this.mode != FormMode.Edit"
  />
</div>
